<div class="counts">
  <sc-flex *ngIf="counts?.total > 0">
    <div class="bar total">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.total-count"></sc-dictionary-label>
      {{counts?.total}}
    </div>
    <div class="bar planned" [style.flex-grow]="counts?.planned" *ngIf="counts?.planned > 0">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.planned-count"></sc-dictionary-label>
      {{counts?.planned}}
    </div>
    <div class="bar inProcessing" [style.flex-grow]="counts?.inProcessing" *ngIf="counts?.inProcessing > 0">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.in-progress-count"></sc-dictionary-label>
      {{counts?.inProcessing}}
    </div>
    <div class="bar waitingForPull" [style.flex-grow]="counts?.waitingForPull" *ngIf="counts?.waitingForPull > 0">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.waiting-for-pull-count"></sc-dictionary-label>
      {{counts?.waitingForPull}}
    </div>
    <div class="bar finished" [style.flex-grow]="counts?.finished" *ngIf="counts?.finished > 0">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.finished-count"></sc-dictionary-label>
      {{counts?.finished}}
    </div>
    <div class="bar paused" [style.flex-grow]="counts?.paused" *ngIf="counts?.paused > 0">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.paused-count"></sc-dictionary-label>
      {{counts?.paused}}
    </div>
    <div class="bar vehicles" [style.flex-grow]="counts?.vehicles" *ngIf="counts?.vehicles > 0">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.vehicles-count"></sc-dictionary-label>
      {{counts?.vehicles}}
    </div>
  </sc-flex>
</div>
